import { render, staticRenderFns } from "./franchisee-bill-details.vue?vue&type=template&id=b8ce98ea&scoped=true&"
import script from "./franchisee-bill-details.vue?vue&type=script&lang=js&"
export * from "./franchisee-bill-details.vue?vue&type=script&lang=js&"
import style0 from "./franchisee-bill-details.vue?vue&type=style&index=0&id=b8ce98ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ce98ea",
  null
  
)

export default component.exports